import { AfterViewInit, Component, ElementRef, Input, OnChanges, OnDestroy, SimpleChanges, ViewChild } from '@angular/core';
import { Workspace } from '@model-main/workspaces/workspace';
import { BehaviorSubject } from 'rxjs';
import { EditTabs, WorkspaceModalService } from '../../../../shared';

const DESCRIPTION_HEIGHT_THRESHOLD = 64;

@Component({
    selector: 'workspace-header',
    templateUrl: './workspace-header.component.html',
    styleUrls: ['./workspace-header.component.less']
})
export class WorkspaceHeaderComponent implements OnChanges, AfterViewInit, OnDestroy {
    readonly isExpanded$ = new BehaviorSubject<boolean>(false);
    readonly canExpand$ = new BehaviorSubject<boolean>(false);
    hasGroups = false;
    avatars: string[];
    resizeObserver?: ResizeObserver;

    @Input() workspace: Workspace;
    @ViewChild('description') descriptionEl: ElementRef<HTMLElement>;

    constructor(
        private workspaceModal: WorkspaceModalService
    ) {
    }

    ngOnChanges(changes: SimpleChanges): void {
        const { workspace } = changes;
        if (workspace) {
            // Update avatars
            this.avatars = this.workspace.permissions
                .filter(permission => permission.user)
                .slice(0, 3)
                .map(permission => permission.user as string);

            this.hasGroups = this.workspace.permissions.some(permission => permission.group);
        }
    }

    ngAfterViewInit(): void {
        const content = this.descriptionEl.nativeElement.firstElementChild;
        if (content) {
            this.resizeObserver = new ResizeObserver(entries => {
                if (entries.length > 0) {
                    const height = entries[0].contentRect.height;
                    if (height <= DESCRIPTION_HEIGHT_THRESHOLD) {
                        this.canExpand$.next(false);
                        this.setExpanded(false);
                    } else {
                        this.canExpand$.next(true);
                    }
                }
            });
            this.resizeObserver.observe(content);
        }
    }

    ngOnDestroy(): void {
        if (this.resizeObserver) {
            this.resizeObserver.disconnect();
        }
    }

    openDeleteWorkspaceModal(): void {
        this.workspaceModal.deleteWorkspace(this.workspace);
    }

    openEditWorkspaceModal(): void {
        this.workspaceModal.editWorkspace(this.workspace, 'header');
    }

    openMembersModal(): void {
        this.workspaceModal.editWorkspace(this.workspace, 'header', [EditTabs.PERMISSIONS]);
    }

    setExpanded(expanded: boolean): void {
        if (expanded !== this.isExpanded$.value) {
            this.isExpanded$.next(expanded);
            this.descriptionEl.nativeElement.scrollTop = 0;
        }
    }

}
